// グランドナビゲーション LEFTへ
$(function() {
    GnavResize();
});
function GnavResize(){
    var ww = jQuery(window).width();
    var gnav = $('.g-nav');
    if (ww < 1140){
        $('.Header__FlexItem--logo').before(gnav);
        $('.g-nav').css({display:'block'});
    } else{
        $('#section-header .Header__Wrapper').after(gnav);
        $('.g-nav').css({display:'block'});
    }


};

$(window).on('resize', function(){
    GnavResize();
});

 ////////* スクロールアクション *////////
	 
 $(window).scroll(function (){
	$(".ac").each(function(){
		var imgPos = $(this).offset().top;    
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > imgPos - windowHeight + 100){
			$(this).addClass("in");
		}
    });
});



